export default "__VITE_ASSET__DD2EV0fW__"